import { render, staticRenderFns } from "./MaturedProductsChart.vue?vue&type=template&id=5c53e942&scoped=true&"
import script from "./MaturedProductsChart.vue?vue&type=script&lang=js&"
export * from "./MaturedProductsChart.vue?vue&type=script&lang=js&"
import style0 from "./MaturedProductsChart.vue?vue&type=style&index=0&id=5c53e942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c53e942",
  null
  
)

export default component.exports